module.exports = {
  appUrl: 'https://supportguy.staging2.groovehq.com/',
  appDomain: 'staging2.groovehq.com',
  kbProxyDomain: 'hosting-staging.groovehq.help',
  api_url: 'https://api.staging2.groovehq.com',
  graphql_url: 'https://graphql-gateway-staging2.staging.groovehq.com/graphql',
  app_graphql_url: 'https://api.staging2.groovehq.com/v2/graphql',
  report_url: 'https://graphql-gateway-staging2.staging.groovehq.com/reports',
  embeddable_cards_url:
    'https://graphql-gateway-staging2.staging.groovehq.com/embeddable_cards/proxy',
  realtime_url: 'realtime-staging.staging.groovehq.com',
  s3_url: 's3.amazonaws.com',
  vapidPublicKey:
    'BGQuuUqXO9ydBkiA-6GUBfUj4v_EsZ5f-aElLy8dfcBtNvc9fUdTYubt7_F95-u8DjO93My1E0vplOfBKAUNU0g=',
  stripePublicKey: 'pk_test_W2m1TzZq858q0esR0oFeMl0V',
  filestackKey: 'AbnxTnzehQ4KY9hgqQ767z',
  filestackRegion: 'us-east-1',
  filestackBucket: 'groove-filestack-staging',
  showReports: true,
  showSettings: true,
  api_concurrency: 20,
  gtm_segment: 'Application',
  gtm_version: 'staging',
  gtm_containerid: 'GTM-MQ94GV3',
  gtm_auth: 'mYVyrA1hQLLYvvjqsdPodQ',
  gtm_preview: 'env-8',
  google_recaptcha_site_key: '6LdhCn4UAAAAAH0OXvFAtu8mqe3tSwNsiVc3AO_n',
  integrationsApiUrl: 'https://integrations.groovehq.com',
  integrationsApiConcurrency: 4,
  githubAppName: 'groovehq-staging',
  chatServerUrl: 'https://chat-server-cluster.staging.groovehq.com',
  chatIdentityServerUrl: 'https://vector.im',
  emojiWidth: 280,
  emojiHeight: 399,
  trialDays: 15,
  sygnalServerUrl: 'http://sygnal.default.svc.cluster.local',
}
